/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `lt_23` - Less than 23
 * * `gte_23` - Greater than or equal 23
 */
export enum DriverAgeEnum {
  LT_23 = 'lt_23',
  GTE_23 = 'gte_23',
}
